import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
import { SpecialBook } from '../adhoc/blog/all-wrapped.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Near the end of 2020, we had a new family member...`}</p>
    <h1>{`Welcome!`}</h1>
    <p>{`Welcome to this new world and welcome to our family! You and your elder brother are my special little ones who one day will help make our world better. 🥰 `}</p>
    <p>{`Love, ❤️`}</p>
    <p>{`from Mom and Dad.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/6c3e32751d4d92097e7115edf7e1c280/a4262/alex.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "108.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFX0lEQVQ4yyWUWW8b9xXF+ZUKBOhDEKRuG1ipN1lxtG+kLIkUKYn7Tg73VSTFnSKphYtWipRJRY4tx6mNoE/tQ4IURb/Nr1fsw8UMMDPnf+5ZRtVqdwlHo5g9Pm5vrhh028QcPvZ8YZqlMrVCgQOZiM2Nf9uCT29ka3YG++s5bJrv2Fl4RtpjxK1bwbI2g2q/WMWrKGwadjk/bXPXvyThVki4ApRSGRrFErVsjpDFic9gxrdtQj87h1Uzg2tjhq2ZCVLuHZzaJYzLL1GVKjX8SgCN1sh+dp+fbgdklTAJpzJmGrG6CRjtKDtWvAYTfoORnflFYTaFe10Av39MzKrFo1djmH+KKhpLYbM6WFjV4xCQT++G5MMxYjYvcbuXiMVFUAAf1vXKul79LqalVWH5Arcw1AtgYEdN2LIpbL9FpTUrLGu2mZ7bYFNr4f2wRzWdJmr1CKiHsNkpDG3jVR/AfDI2zTq66Rc41l6x9eobAZ4b62iYe4LqiTrE8yU/T16uMz2vo9dtcVIqCJBrDBgyOVB2raKfEZdWtnitxa7ZEMCXWFenMEw/Fi1nyfjMbM8LYCBxxH51SDFfodU44K53TvegQmDXJizdhMwPgLKumBa1OykkUiS9PjFlUXRV49Et4BQtsz4jxqXnqD4MOny4vWN02aXfbtBrNzkq5oi53MRdHiJ2F7lonOuLKz58+Mj9/UdJwzntZpNaLsdBMY9FmCbsWtFWAMMOG3G3i2QkSqDaxFdqEPcFx2Bxt49mtc5oeMe79x95f/93BoMRhXSGbFihlAjSLKSpphRyPhPm5Rfi8oObVidJJYql3MJS7ZLwR8itarjIlxgORwx6VwwH17y7u5Vrj8FFh+vuIYfFBLW9IPmglVYxiXlpElVa2OTDcdK5OrnaCbViQVbe53gvztlhje5xnXo5S1WYlGVy6TDZVIDbwZl85yDh0BExv6aVj4rr0xJsQS8HjPLQTjkdlHYolPN7EvKUfBwllxKAhMJe1EM6ZJexEXFtUd+PUEn6caw+x7zwLcXgQy1XUGXta7hmvyZmWSMdsJISt6Jyati6Lv39/4TMGsniioRXIzXbkvZoaJUTpP0Wdmf+im7yS5LyXty2heooHyPpMQhtDYp+nsD2Agnba8ImtbRkTVbaHIMkXToCJo00ZpGoRU05aqeeCREzr2H47k8outmxMarD/bCEd1XS/koCOyktmGRTwrq9+Ezup9DPTaCefIRm6htWpx6zMfeCrBzQSHklsy0u6zlM8o5l8QklkUN1kPaT8myT8e9SiDhwmfREFDeVvQipkJdGKcuVZHN41eHntwM+3t1we37EVSPL7cURvUYOy9Iz1p9/JTpaUVXibnGzRL2YxWM3YzRoSUjGluencZhECr8Lv8siY2ZDPU/7sMLNSZGTrMLwtM5Nq0J4dwWtrF0IWFA9uPuQqUIqQiLoJRMLkooEKGYS8mPNyA82Q7OS57JzxN8m/ozisXJ3VhdAP286VUbdA8ohM/bVp5TCsvK+ROHmvEW/cziu3w/9c94Nr8fz9uZifL2/7XMvq77tdzlr5BkJs9NCmDetMv3jIsFdNfrFSWJOA6p//fo7v/77v3z+9Jnr02M6zQoxv2iYS/HmssMbacWodyYHXYgJHTqVPUZnTbr5kOiYk5iZ+f7RH1iZ+ILw9jyqVNBF7/Kcf/72Hz7/8g869RIntQJnxzUGwvzmojUGHvZOubs+5eqoxA+9Nu289F2yV4k5sU1/iWP6j8S2pHpO7YLk0MRp+2QM+sunn/lx1OeqKw7K9M9OxjO4aIs0J5jVEq/1Wcnr8jivbWGa1E0QX/8Lezsv+R+wrl8yE9bLMwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Your Are Special",
            "title": "Your Are Special",
            "src": "/static/6c3e32751d4d92097e7115edf7e1c280/0a47e/alex.png",
            "srcSet": ["/static/6c3e32751d4d92097e7115edf7e1c280/8a4e8/alex.png 150w", "/static/6c3e32751d4d92097e7115edf7e1c280/5a46d/alex.png 300w", "/static/6c3e32751d4d92097e7115edf7e1c280/0a47e/alex.png 600w", "/static/6c3e32751d4d92097e7115edf7e1c280/a4262/alex.png 814w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Your Are Special`}</figcaption>{`
  `}</figure>
    <p>{`Here's your `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`You are S.P.E.C.I.A.L`}</code>{` ebook!`}</p>
    <SpecialBook mdxType="SpecialBook" />
    <p>{`made by Dad, William, powered by `}<a parentName="p" {...{
        "href": "https://nodlik.github.io/react-pageflip/"
      }}>{`STFlip`}</a>{` and `}<a parentName="p" {...{
        "href": "https://www.flaticon.com/"
      }}>{`Flaticon`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      